
import hljs from "highlight.js/lib/core";
import sqf from "highlight.js/lib/languages/sqf";
import { NConfigProvider } from "naive-ui";
import { defineComponent } from "vue";
import App from "./App.vue";

hljs.registerLanguage("sqf", sqf);

export default defineComponent({
	components: { App, NConfigProvider },
	setup: () => ({
		// Data
		hljs,
	}),
});
